import type { IBrandConfig } from './types';

const PHSAFE_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: {
    kind: 'external',
    url: 'https://www.profesionalhosting.com/contratos',
  },
  termsOfService: {
    kind: 'external',
    url: 'https://www.profesionalhosting.com/contratos',
  },
  websiteTermsOfUse: { kind: 'none' },
  refundPolicy: { kind: 'none' },
  idTheftProtection: { kind: 'none' },
  licensor: 'intersections',
  vaultProject: 'phsafe',
  adaChat: false,
  accountDetails: true,
  secureUpload: false,
  plan: false,
  security: false,
  missingPII: false,
  finishSetup: false,
  defaultBillingCategoryKey: 'privacy_breach',
  copyRightEntity: 'Soluciones Web On Line SL',
  hasCustomerServiceSupport: false,
  ssoRedirectURL: null,
  carouselBanners: false,
  dwEmailVerification: {
    adaChat: false,
    signInButton: true,
    supportAt: null,
    availability: null,
  },
  supportPage: {
    pageTitle: {
      active: false,
    },
    customerSupportTitle: {
      active: false,
    },
    faq: {
      active: true,
    },
    pages: [
      {
        title: 'Professional Hosting',
        description: 'Visit our knowledge base',
        href: 'https://kb.profesionalhosting.com',
        icon: 'support-faq',
        customerSupport: false,
      },
    ],
    call: {},
    mail: {
      active: false,
    },
    email: {
      active: true,
      address: 'soporte@profesionalhosting.es',
      customerSupport: true,
    },
  },
};

export default PHSAFE_BRAND_CONFIG;
